<template>
  <div>
    <div class="flex flex-between mb8">
      <div class="header-time-box" v-if="$store.state.role === 'school-role' || $store.state.role === 'draw-role'">
        申报时间：{{ startTime }}—{{ endTime }}
      </div>
      <div class="" v-else></div>
      <!--btnShow == true  &&-->  
      <div class="add-btn" v-if="btnShow == true && titleType == 'alApply'" @click="jumpPage(type)">
                             <!-- 新增典型大案例 -->
                             新增网络育人创新联盟
      </div>
      <div class="add-btn" v-if="btnShow == true && titleType == 'xal'" @click="jumpPage(type)">
                             新增典型小案例
      </div>
    </div>
    <div class="header-search-box flex align-items-center border-box" v-if="btnShow == true &&  titleType !== 'alApply' && titleType !== 'xal' ">
      <div class="flex align-items-center">
        <div v-if="titleType === 'szStudio'">课程名称:</div>
        <div v-if="titleType === 'educationalBrand'">工作室名称：</div>
        <!--<div v-if="titleType === 'szMicroClass'">思政微课名称：</div> -->
        <input
          v-if="titleType === 'szStudio'"
          class="input-style"
          type="text"
          v-model="queryCriteria.name"
        />
        <input
          v-if="titleType === 'educationalBrand'"
          class="input-style"
          type="text"
          v-model="queryCriteria.name"
        />
      </div>
      <div class="flex align-items-center">
        <div v-if="titleType === 'alApply' || titleType === 'xal'">标题：</div>
        <div v-else>作品名称：</div>
        <input
          class="input-style"
          type="text"
          v-model="queryCriteria.zpname"
          placeholder=""
        />
      </div>
      <div class="flex align-items-center"  >
        <div>资料完整：</div>
        <a-select
          default-value="全部"
          style="width: 120px;margin-right:30px;"
          @change="handleChange"
        >
          <a-select-option value=""> 全部 </a-select-option>
          <a-select-option value="0"> 完整 </a-select-option>
          <a-select-option value="1"> 未完整 </a-select-option>
        </a-select>
      </div>
      <div class="add-btn" v-if="btnShow == true && titleType === 'szStudio'"  @click="reset('szStudio')">
        重置
      </div>
      <div class="add-btn" v-if="btnShow == true && titleType === 'educationalBrand'"  @click="reset('educationalBrand')">
        重置
      </div>
       <!--<div class="add-btn" v-if="btnShow == true && titleType === 'alApply'"  @click="reset('alApply')">
        重置
      </div>-->
      <div
        class="search-btn flex flex-center align-items-center"
        @click="goQuery"
      >
        <img class="img-box" src="@/assets/images/img48.png" alt="" />
        <div>查询</div>
      </div>
      <div class="add-btn"  @click="jumpPage(type)">
                          新增
      </div>
      
    </div>
    <!-- 学校端：网络育人创新联盟列表筛选 -->
    <div
      v-if="alApplySchoolFilter"
      class="list-filter-panel"
    >
      <div class="list-filter-row filter-dimension-grid">
        <div class="filter-dimension-block filter-dimension-block--primary">
          <div class="filter-dimension-title">大赛分组</div>
          <div class="filter-chip-list filter-chip-list--lg">
            <span
              class="filter-chip filter-chip--lg"
              :class="{ active: !queryCriteria.levelType }"
              @click="setSchoolLevelFilter()"
            >全部</span>
            <span
              class="filter-chip filter-chip--lg"
              :class="{ active: queryCriteria.levelType === '1' }"
              @click="setSchoolLevelFilter('1')"
            >中职组</span>
            <span
              class="filter-chip filter-chip--lg"
              :class="{ active: queryCriteria.levelType === '2' }"
              @click="setSchoolLevelFilter('2')"
            >高职组</span>
          </div>
        </div>
        <!-- <div class="filter-dimension-block filter-dimension-block--primary">
          <div class="filter-dimension-title">团队类型</div>
          <div class="filter-chip-list filter-chip-list--lg">
            <span
              class="filter-chip filter-chip--lg"
              :class="{ active: !queryCriteria.teamType }"
              @click="setSchoolTeamFilter()"
            >全部</span>
            <span
              class="filter-chip filter-chip--lg"
              :class="{ active: queryCriteria.teamType === 'teacher' }"
              @click="setSchoolTeamFilter('teacher')"
            >教师团队</span>
            <span
              class="filter-chip filter-chip--lg"
              :class="{ active: queryCriteria.teamType === 'student' }"
              @click="setSchoolTeamFilter('student')"
            >学生团队</span>
          </div>
        </div> -->
      </div>
    </div>
    <div>
    	<!--:scroll="{ x: 1280 }"-->
      <a-table
        style="text-align: center"
        :locale="{ emptyText: '暂无数据' }"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        :bordered="true"
        rowKey="id"
      >
        <!-- :scroll="{ x: 100000 }" -->
        <template slot="sequenceNumber" slot-scope="text, record, index">
          {{ index + 1 }}
        </template>
        <span
          class="flex flex-around"
          slot="action"
          slot-scope="record"
          style="margin: 0 20px"
        >
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="editInfo(record)"
            v-if="btnShow == true && record.subState=='0'"
          >
            <img class="img-box" src="@/assets/images/img42.png" alt="" />
            <span>编辑</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="deleteInfo(record)"
            v-if="btnShow == true && record.subState=='0'"
          >
            <img class="img-box" src="@/assets/images/img43.png" alt="" />
            <span>删除</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="preview(record)"
          >
            <img
              class="img-box-preview"
              src="@/assets/images/img51.png"
              alt=""
            />
            <span>预览</span>
          </div>
        </span>
        <template slot="applyFilesFull" slot-scope="text">
          <img
            v-if="text == 0"
            class="img-box-hint"
            src="@/assets/images/img57.png"
            alt=""
            title="资料完整"
          />
          <img
            v-else
            class="img-box-hint"
            src="@/assets/images/img58.png"
            alt=""
            title="资料不完整"
          />
        </template>
         <template
          style="width: 100px"
          slot="applyFiles"
          slot-scope="text, record"
        >
          <tr
            v-for="(item, index) in record.expertApplys"
            :key="index"
            :style="
              index + 1 == record.expertApplys.length
                ? ''
                : 'border-bottom: 1px solid #e8e8e8;'
            "
            class="table-tr"
          >
            <img class="ywcimg"
                 v-if="(item.score && item.scoreFile) && (item.score != '-' || item.scoreFile != '-') "
                 src="../../assets/images/ywc.png" alt="" />
            <div class="table-content"  :title="item.expertName" v-if="item.izReview==1"   @click="reviewShow(record,item.expertUserId)">
              <span style="color:#9A0B00;cursor: pointer;" >{{ item.expertName }}</span>
            </div>
            <div  class="table-content" :title="item.expertName" v-else >
            	 <span>{{ item.expertName }}</span>
            </div>
          </tr>
          <span v-if="record.expertApplys.length == 0">-</span>
        </template>
        <template slot="subState" slot-scope="text">
          <div
            v-if="text == 1"
           >已提交</div>
            <div
            v-else
           >未提交</div>
        </template>
        <template slot="levelType" slot-scope="text">
          <span v-if="text == '1' || text == 1">中职组</span>
          <span v-else-if="text == '2' || text == 2">高职组</span>
          <span v-else>-</span>
        </template>
        <!-- <template slot="teamType" slot-scope="text">
          <span v-if="text === 'teacher'">教师团队</span>
          <span v-else-if="text === 'student'">学生团队</span>
          <span v-else>-</span>
        </template> -->
         <template slot="izReview" slot-scope="text, record">
          <!--<span v-if="text==1" style="cursor:pointer;color:#9A0B00;font-weight:600;" @click="reviewShow(record,item.expertUserId)">已评审</span>
          <span v-else>未评审</span>-->
          	<tr
            v-for="(item, index) in record.expertApplys"
            :key="index"
            :style="
              index + 1 == record.expertApplys.length
                ? ''
                : 'border-bottom: 1px solid #e8e8e8;'
            "
            class="table-tr"
          >
            <div class="table-content-score" style="width:100%;">
               <span v-if="item.izReview==1" style="cursor:pointer;color:#9A0B00;font-weight:600;" @click="reviewShow(record,item.expertUserId)">已评审</span>
               <span v-else>未评审</span>
            </div>
          </tr>
          <span v-if="record.expertApplys.length == 0">-</span>
        </template>
        <!--<template slot="score" slot-scope="text,record">
        	<div v-if="previewTimeout!=''">{{previewTimeout}}</div>
          <div v-else>{{ text }}</div>
        </template>-->
        <template slot="avgscore" slot-scope="text">
        	<div v-if="previewTimeout!=''">{{previewTimeout}}</div>
          <div v-else>{{ text }}</div>
        </template>
        <template slot="duration" slot-scope="text">
          <img v-if="
              (text / 1000 / 60).toFixed(0) >= 10 && (text / 1000 / 60).toFixed(0) <= 15
            " class="img-box-hint" src="../../assets/images/img57.png" alt=""
            :title="getTime(text) + '\n时长合格'" />
          <img v-else class="img-box-hint" src="../../assets/images/img58.png" alt="" :title="
              text == '-'
                ? `未上传微课视频`
                : `${getTime(text)}\n视频时长不在10-15分钟内`
            " />
        </template>
      </a-table>
    </div>
    <a-modal
      title="您确定删除吗"
      :visible="showDeleteModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="showDeleteModel = false"
    >
      <p>删除该信息将同步删除关联的申报文件、视频及佐证材料，您确定要删除吗？</p>
    </a-modal>
    <div class="preview-pop-box" v-if="showPreviewPop">
      <!--this.$store.state.region!='5' && this.$store.state.role !='school-role'-->
      <div :class="fullscreen ? 'preview-box-fullscreen' : 'preview-box'">
        <preview
          :preViewData="preViewData"
          type="school"
          @goNewPage="goNewPage"
          @closePreview="showPreviewPop = false"
        ></preview>
      </div>
       <!--<div v-else :class="fullscreen ? 'preview-box-fullscreen' : 'preview-box'">
        <al-preview
          :preViewData="preViewData"
          type="school"
          @goNewPage="goNewPage"
          @closePreview="showPreviewPop = false"
        ></al-preview>
      </div>-->
    </div>
    <div class="preview-pop-box" v-if="isshow">
      <div class="preview-box">
        <!--<expertlist
          :preViewData="preViewData"
          @closePreview="isshow = false"
        ></expertlist>-->
        <expertdata :preViewData="preViewData"
          :expertUserId="expertUserId"
          @closePreview="isshow = false">
        </expertdata>
      </div>
       <!--<div v-else :class="fullscreen ? 'preview-box-fullscreen' : 'preview-box'">
        <al-preview
          :preViewData="preViewData"
          type="school"
          @goNewPage="goNewPage"
          @closePreview="showPreviewPop = false"
        ></al-preview>
      </div>-->
    </div>
    <!-- 网络育人创新联盟：新增前先选择报名信息 -->
    <a-modal
      title="选择已通过的报名信息"
      :visible="enrollSelect.visible"
      ok-text="确定"
      cancel-text="取消"
      width="920px"
      wrap-class-name="enroll-select-modal-wrap"
      :mask-closable="false"
      :get-container="getModalContainer"
      :confirm-loading="enrollSelect.submitting"
      @ok="handleEnrollOk"
      @cancel="closeEnrollSelect"
    >
      <div class="enroll-select-tip">
        请选择一条已通过审核的大赛报名记录，相关信息将自动带入申报表单。
      </div>
      <div
        v-if="!enrollSelect.loading && enrollSelect.list.length"
        class="enroll-filter-panel"
      >
        <div class="enroll-filter-row">
          <a-input-search
            v-model="enrollSelect.keyword"
            placeholder="搜索作品名称、负责人、团队成员"
            allow-clear
            class="enroll-filter-search"
          />
        </div>
        <div class="enroll-filter-row enroll-filter-options">
          <div class="filter-option-group">
            <span class="filter-option-label">大赛分组</span>
            <div class="filter-chip-list">
              <span
                class="filter-chip"
                :class="{ active: !enrollSelect.filterLevelType }"
                @click="setEnrollLevelFilter()"
              >全部</span>
              <span
                class="filter-chip"
                :class="{ active: enrollSelect.filterLevelType === '1' }"
                @click="setEnrollLevelFilter('1')"
              >中职组</span>
              <span
                class="filter-chip"
                :class="{ active: enrollSelect.filterLevelType === '2' }"
                @click="setEnrollLevelFilter('2')"
              >高职组</span>
            </div>
          </div>
          <!-- <div class="filter-option-group">
            <span class="filter-option-label">团队类型</span>
            <div class="filter-chip-list">
              <span
                class="filter-chip"
                :class="{ active: !enrollSelect.filterTeamType }"
                @click="setEnrollTeamFilter()"
              >全部</span>
              <span
                class="filter-chip"
                :class="{ active: enrollSelect.filterTeamType === 'teacher' }"
                @click="setEnrollTeamFilter('teacher')"
              >教师团队</span>
              <span
                class="filter-chip"
                :class="{ active: enrollSelect.filterTeamType === 'student' }"
                @click="setEnrollTeamFilter('student')"
              >学生团队</span>
            </div>
          </div> -->
        </div>
        <div class="enroll-filter-row enroll-filter-footer">
          <a-button  @click="resetEnrollFilter">重置筛选</a-button>
          <span class="enroll-filter-count">
            共 <b>{{ enrollSelect.list.length }}</b> 条，当前显示 <b>{{ filteredEnrollList.length }}</b> 条
          </span>
        </div>
      </div>
      <a-spin :spinning="enrollSelect.loading">
        <div
          v-if="!enrollSelect.loading && !enrollSelect.list.length"
          class="enroll-select-empty"
        >
          暂无已通过的报名信息，请先在「大赛报名」中提交并通过审核后再新增
        </div>
        <div
          v-else-if="!enrollSelect.loading && enrollSelect.list.length && !filteredEnrollList.length"
          class="enroll-select-empty"
        >
          没有匹配的报名记录，请调整筛选条件或点击「重置筛选」
        </div>
        <a-table
          v-else
          class="enroll-select-table"
          size="small"
          bordered
          rowKey="id"
          :loading="enrollSelect.loading"
          :columns="enrollSelectColumns"
          :data-source="filteredEnrollList"
          :pagination="false"
          :scroll="{ y: 320, x: 860 }"
          :locale="{ emptyText: '暂无数据' }"
          :row-selection="enrollRowSelection"
          :custom-row="enrollCustomRow"
          :row-class-name="enrollRowClassName"
        >
          <template slot="enrollLevelType" slot-scope="text">
            {{ formatEnrollLevelType(text) }}
          </template>
          <!-- <template slot="enrollTeamType" slot-scope="text">
            {{ formatEnrollTeamType(text) }}
          </template> -->
          <template slot="enrollTeams" slot-scope="text">
            <team-members-display :value="text" />
          </template>
          <template slot="enrollFormFile" slot-scope="text">
            <a
              v-if="text"
              class="enroll-form-link"
              @click.stop.prevent="openEnrollForm(text)"
            >查看</a>
            <span v-else>-</span>
          </template>
        </a-table>
      </a-spin>
    </a-modal>
    <preview-img ref="enrollPreviewImg" :overlay-z-index="3000"></preview-img>
  </div>
</template>

<script>
import preview from './preview';
import expertlist from "./expertList";
//import alPreview from './alpreview';
import expertdata from "./expertData";
import previewImg from '@/components/previewImg.vue';
import teamMembersDisplay from '@/components/common/teamMembersDisplay.vue';
import { schoolMaxNum , expertDateView, lxEnrollApprovedList } from '@/api/index';
import { formatDuring } from '../../utils/time';
const columns = [
  {
    title: '序号',
    dataIndex: 'sequenceNumber',
    id: 'sequenceNumber',
    align: 'center',
    scopedSlots: { customRender: 'sequenceNumber' },
    width: 55,
  },
  // {
  //   title: "姓名",
  //   dataIndex: "name",
  //   id: "name",
  //   align: "center",
  //   width: 150,
  // },
  {
    title: '课程名称',
    dataIndex: 'name',
    id: 'name',
    align: 'center',
    width: 150,
  },
  {
    title: '作品名称',
    dataIndex: 'zpname',
    id: 'zpname',
    align: 'center',
    width: 150,
  },
  {
    title: '负责人',
    dataIndex: 'principals',
    id: 'principals',
    align: 'center',
    width: 150,
  },
  {
    title: '联系电话',
    dataIndex: 'phone',
    id: 'phone',
    align: 'center',
    width: 150,
  },
  {
    title: '资料完整',
    dataIndex: 'applyFilesFull',
    id: 'applyFilesFull',
    align: 'center',
    scopedSlots: { customRender: 'applyFilesFull' },
    width: 100,
  },
  {
    title: '专业名称',
    dataIndex: 'major3_dictText',
    id: 'major3_dictText',
    align: 'center',
    width: 150,
  },
  {
    title: '操作',
    id: 'action',
    align: 'center',
    width: 354,
    fixed: 'right',
    scopedSlots: { customRender: 'action' },
  },
];
export default {
  name: '',
  components: { preview, expertlist, expertdata, previewImg, teamMembersDisplay },
  props: {
    columns: {
      type: Array,
      default: () => columns,
    },
    loading: Boolean,
    dataList: {
      type: Array,
      default: () => [],
    },
    titleType: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    startTime: {
      type: String,
      default: '',
    },
    endTime: {
      type: String,
      default: '',
    },
    pagination: {
      type: Object,
    },
    btnShow: {
      type: Boolean,
    },
  },
  data() {
    return {
      showDeleteModel: false,
      deteleId: null,
      showPreviewPop: false,
      fullscreen: false,
      preViewData: null,
      queryCriteria: {
        name: '',
        principals: '',
        Integrity: '',
        zpname: '',
        levelType: '',
        teamType: '',
      },
      data: [],
      isadd: '',
      isshow:false,
      expertUserId:'',
      previewTimeout:'',
      reviewStartTimestamp:'',
      reviewEndTimestamp:'',
      // alApply 新增：选择已通过报名信息
      enrollSelect: {
        visible: false,
        loading: false,
        submitting: false,
        list: [],
        selected: null,
        selectedId: null,
        applyType: 4,
        keyword: "",
        filterLevelType: undefined,
        filterTeamType: undefined,
      },
      enrollSelectColumns: [
        {
          title: "作品名称",
          dataIndex: "zpname",
          key: "zpname",
          width: 150,
          ellipsis: true,
        },
        {
          title: "负责人",
          dataIndex: "principal",
          key: "principal",
          width: 88,
          ellipsis: true,
        },
        {
          title: "大赛分组",
          dataIndex: "levelType",
          key: "levelType",
          width: 76,
          scopedSlots: { customRender: "enrollLevelType" },
        },
        // {
        //   title: "团队类型",
        //   dataIndex: "teamType",
        //   key: "teamType",
        //   width: 88,
        //   scopedSlots: { customRender: "enrollTeamType" },
        // },
        {
          title: "团队成员",
          dataIndex: "teams",
          key: "teams",
          width: 200,
          scopedSlots: { customRender: "enrollTeams" },
        },
        {
          title: "报名表",
          dataIndex: "formFilePath",
          key: "formFilePath",
          width: 64,
          scopedSlots: { customRender: "enrollFormFile" },
        },
      ],
    };
  },
  computed: {
    enrollRowSelection() {
      return {
        type: "radio",
        columnWidth: 48,
        selectedRowKeys: this.enrollSelect.selectedId
          ? [this.enrollSelect.selectedId]
          : [],
        onChange: this.onEnrollTableSelect,
      };
    },
    filteredEnrollList() {
      const list = this.enrollSelect.list || [];
      const kw = (this.enrollSelect.keyword || "").trim().toLowerCase();
      const levelType = this.enrollSelect.filterLevelType;
      // const teamType = this.enrollSelect.filterTeamType;
      return list.filter((item) => {
        if (
          levelType !== undefined &&
          levelType !== null &&
          levelType !== "" &&
          String(item.levelType) !== String(levelType)
        ) {
          return false;
        }
        // if (
        //   teamType !== undefined &&
        //   teamType !== null &&
        //   teamType !== "" &&
        //   item.teamType !== teamType
        // ) {
        //   return false;
        // }
        if (!kw) return true;
        const haystack = [
          item.zpname,
          item.principal,
          this.formatEnrollLevelType(item.levelType),
          // this.formatEnrollTeamType(item.teamType),
          item.teams,
        ]
          .filter(Boolean)
          .join(" ")
          .toLowerCase();
        return haystack.includes(kw);
      });
    },
    alApplySchoolFilter() {
      return (
        this.btnShow &&
        (this.titleType === "alApply" || this.titleType === "xal") &&
        this.$store.state.role === "school-role"
      );
    },
  },
  watch: {
    dataList(newPrice) {
      this.data = newPrice;
    },
    isadd(newPrice) {
      this.isadd = newPrice;
    },
  },
  created() {
//	console.log(this.columns,"1111111");
  },
  mounted() {
  	this.getexpertDateView();
  },
  methods: {
    getTime(time) {
      return formatDuring(time);
    },
  	getexpertDateView() {
      expertDateView().then((res) => {
        if (res.code == 200) {
//        var startTime = parseInt(res.result.startTime);
//        var endTime = parseInt(res.result.endTime);
//        this.reviewStartTime = getTsFormatDate(startTime);
//        this.reviewEndTime = getTsFormatDate(endTime);
          this.reviewStartTimestamp = res.result.startTime;
          this.reviewEndTimestamp = res.result.endTime;
//        console.log(this.reviewStartTimestamp,this.reviewEndTimestamp);
					this.getPreviewTimeout();
        }
      });
    },
  	getPreviewTimeout() {
      var date1 = new Date();
      var timestamp = Date.parse(date1);
//    console.log(timestamp,this.reviewStartTimestamp,this.reviewEndTimestamp);
      if (
        timestamp > this.reviewStartTimestamp &&
        timestamp < this.reviewEndTimestamp
      ) {
        this.previewTimeout = '评审中';
      } else if(timestamp<=this.reviewStartTimestamp){
        this.previewTimeout = '暂未评审';
      }else{
      	this.previewTimeout = '';
      }
    },
  	reviewShow(row,expertUserId){
  		 this.isshow=true;
//		 console.log(row);
  		 this.preViewData = row;
  		 this.expertUserId=expertUserId;
  	},
    handleChange(value) {
      this.queryCriteria.Integrity = value;
    },
    goNewPage(flag) {
//    console.log(flag);
      this.fullscreen = flag;
    },
    reset(type){
      if(type=="szStudio"){
        this.queryCriteria.principals = "";
      }else if(type=="educationalBrand"){
        this.queryCriteria.name = "";
      }
      this.queryCriteria.zpname = "";
      this.goQuery();
    },
    getModalContainer() {
      return document.body;
    },
    handleAlApplyAdd() {
      this.openEnrollSelect(4);

    },
    /** 暂存已选报名，同意承诺书后继续上传 */
    saveAlApplyEnrollPending(enroll, applyType) {
      sessionStorage.setItem(
        "alApplyEnrollPending",
        JSON.stringify({
          applyType: applyType || 4,
          enrollId: enroll.id,
          zpname: enroll.zpname,
          principals: enroll.principal,
          levelType: enroll.levelType,
          teamType: enroll.teamType,
          teams: enroll.teams,
          suggestion: enroll.suggestion,
        })
      );
    },
    goAlApplyDataUploadFromEnroll(enroll, applyType) {
      this.$router.push({
        name: `${this.$route.name}DataUpload`,
        params: {
          applyType: applyType || 4,
          new: "new",
          fromEnroll: true,
          enrollId: enroll.id,
          zpname: enroll.zpname,
          principals: enroll.principal,
          levelType: enroll.levelType,
          teamType: enroll.teamType,
          teams: enroll.teams,
          suggestion: enroll.suggestion,
        },
      });
    },
    jumpPage(type) {
//  	console.log(type);
      if (type === '') {
        let isAgree = window.localStorage.getItem('isAgree');
        if (isAgree === 'true') {
          let applyType = 0;
          if (this.$route.name === 'szStudio') {
            applyType = 1;
          } else if (this.$route.name === 'educationalBrand') {
            applyType = 2;
          } else {
            applyType = 3;
          }
          if(this.$route.name === 'alApply'){
      	    applyType = 4;
          }else if(this.$route.name === 'xal'){
            applyType = 1;
          }
          // this.$emit("showAddPops", applyType);
          var data = {
            applyType: applyType,
          };
          schoolMaxNum(data).then((res) => {
            if (res.code == 200) {
              if (res.result == 0) {
                this.isadd = true;
              } else {
                if (this.dataList.length >= res.result) {
                  this.isadd = false;
                } else {
                  this.isadd = true;
                }
              }
              if (this.isadd == true) {
                this.$router.push({
                  name: `${this.$route.name}DataUpload`,
                  params: {
                    applyType,
                    new: 'new',
                  },
                });
              } else {
                this.$message.warning('本学校上报数据已达上限');
              }
            }
          });
        } else {
        	if(this.$route.name === 'alApply'){
        		this.$router.push({ name: `szStudioLetterCommitment` });
        	}else if(this.$route.name === 'xal'){
            this.$router.push({ name: `xalLetterCommitment` });
          }else{
        		this.$router.push({ name: `${this.$route.name}LetterCommitment` });
        	}
          
        }
      } else {
        this.$emit('showAddPop', type);
      }
    },
    closeEnrollSelect() {
      this.enrollSelect.visible = false;
      this.enrollSelect.selected = null;
      this.enrollSelect.selectedId = null;
      this.resetEnrollFilter();
    },
    resetEnrollFilter() {
      this.enrollSelect.keyword = "";
      this.enrollSelect.filterLevelType = undefined;
      this.enrollSelect.filterTeamType = undefined;
    },
    setEnrollLevelFilter(value) {
      this.enrollSelect.filterLevelType =
        value === undefined || value === null || value === ""
          ? undefined
          : String(value);
    },
    setEnrollTeamFilter(value) {
      this.enrollSelect.filterTeamType =
        value === undefined || value === null || value === ""
          ? undefined
          : value;
    },
    formatEnrollLevelType(levelType) {
      if (levelType === "1" || levelType === 1) return "中职组";
      if (levelType === "2" || levelType === 2) return "高职组";
      return levelType || "-";
    },
    formatEnrollTeamType(teamType) {
      if (teamType === "teacher") return "教师团队";
      if (teamType === "student") return "学生团队";
      return teamType || "-";
    },
    isEnrollSelected(item) {
      return String(this.enrollSelect.selectedId) === String(item.id);
    },
    selectEnrollCard(item) {
      this.enrollSelect.selectedId = item.id;
      this.enrollSelect.selected = item;
    },
    onEnrollTableSelect(selectedRowKeys, selectedRows) {
      const row = selectedRows && selectedRows[0];
      if (row) {
        this.selectEnrollCard(row);
      }
    },
    enrollCustomRow(record) {
      return {
        on: {
          click: () => this.selectEnrollCard(record),
        },
      };
    },
    enrollRowClassName(record) {
      return this.isEnrollSelected(record) ? "enroll-table-row-selected" : "";
    },
    getSelectedEnroll() {
      if (this.enrollSelect.selected) {
        return this.enrollSelect.selected;
      }
      if (this.enrollSelect.selectedId == null || this.enrollSelect.selectedId === "") {
        return null;
      }
      return (
        this.enrollSelect.list.find(
          (item) => String(item.id) === String(this.enrollSelect.selectedId)
        ) || null
      );
    },
    openEnrollForm(path) {
      if (!path || !this.$refs.enrollPreviewImg) return;
      this.$refs.enrollPreviewImg.init(path);
    },
    openEnrollSelect(applyType) {
      this.enrollSelect.applyType = applyType || 4;
      this.enrollSelect.visible = true;
      this.enrollSelect.loading = true;
      this.enrollSelect.selected = null;
      this.enrollSelect.selectedId = null;
      this.enrollSelect.list = [];
      this.resetEnrollFilter();
      lxEnrollApprovedList()
        .then((res) => {
          if (res.code === 200) {
            this.enrollSelect.list = res.result || [];
            if (!this.enrollSelect.list.length) {
              this.$message.warning(
                "暂无已通过的大赛报名记录，请先在「大赛报名」中提交并通过审核后再新增"
              );

            }

          } else {
            this.$message.error(res.message || "获取报名信息失败");
          }
        })
        .catch(() => {
          this.$message.error("获取报名信息失败，请稍后重试");
        })
        .finally(() => {
          this.enrollSelect.loading = false;
        });
    },
    handleEnrollOk() {
      const e = this.getSelectedEnroll();
      if (!e) {
        this.$message.info("请先选择一条已通过的报名信息");
        return false;
      }
      const applyType = this.enrollSelect.applyType || 4;
      this.enrollSelect.submitting = true;
      return schoolMaxNum({ applyType })
        .then((res) => {
          if (res.code !== 200) {
            this.$message.error(res.message || "校验失败");
            return Promise.reject();
          }
          const canAdd =
            res.result === 0 || this.dataList.length < res.result;
          if (!canAdd) {
            this.$message.warning("本学校上报数据已达上限");
            return Promise.reject();
          }
          this.closeEnrollSelect();
          const isAgree = window.localStorage.getItem("isAgree");
          if (isAgree !== "true") {
            this.saveAlApplyEnrollPending(e, applyType);
            this.$router.push({
              name: "szStudioLetterCommitment",
              query: { from: "alApplyEnroll" },
            });
            return Promise.reject();
          }
          this.goAlApplyDataUploadFromEnroll(e, applyType);
        })
        .catch(() => Promise.reject())
        .finally(() => {
          this.enrollSelect.submitting = false;
        });
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      let queryParam = {};
      queryParam.page = pagination.current;
      queryParam.size = pagination.pageSize;
      queryParam.realname = this.queryCriteria.schoolName;
      queryParam.name = this.queryCriteria.name;
      queryParam.principals = this.queryCriteria.principals;
      queryParam.Integrity = this.queryCriteria.Integrity;
      queryParam.zpname = this.queryCriteria.zpname;
      queryParam.levelType = this.queryCriteria.levelType || '';
      // queryParam.teamType = this.queryCriteria.teamType || '';
      this.$emit('getLxApplyApplylist', queryParam);
    },
    handleOk() {
      this.showDeleteModel = false;
      this.$emit('deleteApply', this.deteleId);
    },
    deleteInfo(row) {
      this.showDeleteModel = true;
      this.deteleId = row.id;
    },
    editInfo(row) {
      this.$emit('editInfo', row);
    },
    preview(row) {
      this.showPreviewPop = true;
      console.log(row,"1111111");
      this.preViewData = row;
      // this.$emit("editInfo", row,'preview');
    },
    setSchoolLevelFilter(value) {
      this.queryCriteria.levelType =
        value === undefined || value === null || value === ""
          ? ""
          : String(value);
      if (this.alApplySchoolFilter) this.goQuery();
    },
    setSchoolTeamFilter(value) {
      this.queryCriteria.teamType =
        value === undefined || value === null || value === ""
          ? ""
          : value;
      if (this.alApplySchoolFilter) this.goQuery();
    },
    goQuery() {
      const pagination = {
        current: 1,
        pageSize: 20,
      };
      this.handleTableChange(pagination);
    },
  },
};
</script>

<style scoped lang="scss">
.header-time-box {
  // width: 363px;
  // height: 32px;
  line-height: 1;
  text-align: center;
  background: #f6d6d0;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #9A0B00;
  border-radius: 6px;
  padding: 8px 10px;
}
.add-btn {
  width: 160px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #9A0B00;
  border-radius: 6px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
.mb8 {
  margin-bottom: 8px;
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 9px;
}
.img-box-preview {
  width: 21px;
  height: 21px;
  margin-right: 9px;
}
.table-box {
  text-align: center;
}
.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }
  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}
.header-search-box {
  font-size: 14px;
  padding-left: 7px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #383838;
  margin-top: 10px;
  margin-bottom: 15px;
  .input-style {
    width: 180px;
    height: 30px;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    padding: 8px 12px;
    margin: 0 20px 0 6px;
  }
  .search-btn {
    width: 100px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    text-align: center;
    color: #fff;
    background: #9A0B00;
    border-radius: 6px;
    margin-left: 10px;
    margin-right: 20px;
    .img-box {
      width: 12px;
      height: 14px;
      margin-right: 8px;
    }
  }
}
.img-box-hint {
  width: 18px;
  height: 18px;
  margin-right: 9px;
  display: inline-block;
  margin: 0 auto;
}
.table-content {
  /* margin: 20px 0; */
  /* text-align: center; */
  /* float: right; */
  margin: 0 auto;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/.ant-table-tbody > tr > td {
  padding: 0 !important;
  height: 60px;
}
.list-filter-panel {
  margin-bottom: 14px;
  padding: 14px 16px;
  background: #f8faff;
  border: 1px solid #d6e4ff;
  border-radius: 10px;
}
.list-filter-row {
  margin-bottom: 12px;
}
.list-filter-row:last-child {
  margin-bottom: 0;
}
.list-filter-footer {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding-top: 4px;
  border-top: 1px dashed #e0e0e0;
}
.filter-dimension-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}
.filter-dimension-block {
  padding: 12px 16px;
  background: #fff;
  border: 1px solid #e6eefc;
  border-radius: 8px;
}
.filter-dimension-block--primary {
  border-color: #b8d4ff;
  background: linear-gradient(180deg, #fff 0%, #f3f8ff 100%);
  box-shadow: 0 1px 4px rgba(0, 90, 245, 0.08);
}
.filter-dimension-title {
  margin-bottom: 10px;
  padding-bottom: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  border-bottom: 1px solid #eef3fc;
}
.filter-dimension-block--primary .filter-dimension-title {
  color: #9A0B00;
  border-bottom-color: #d6e4ff;
}
.filter-chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.filter-chip-list--lg {
  gap: 10px;
}
.filter-chip {
  display: inline-block;
  min-width: 72px;
  padding: 6px 16px;
  font-size: 14px;
  text-align: center;
  color: #555;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s;
}
.filter-chip--lg {
  min-width: 96px;
  padding: 8px 22px;
  border-radius: 8px;
}
.filter-chip:hover {
  color: #9A0B00;
  border-color: #91b8ff;
}
.filter-chip.active {
  color: #fff;
  background: #9A0B00;
  border-color: #9A0B00;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(0, 90, 245, 0.25);
}
@media (max-width: 768px) {
  .filter-dimension-grid {
    grid-template-columns: 1fr;
  }
}
.enroll-select-tip {
  margin-bottom: 14px;
  padding: 10px 14px;
  font-size: 13px;
  color: #555;
  background: #eef4ff;
  border-radius: 8px;
  border: 1px solid #d6e4ff;
}
.enroll-filter-panel {
  margin-bottom: 14px;
  padding: 14px 16px;
  background: #f8faff;
  border: 1px solid #d6e4ff;
  border-radius: 10px;
}
.enroll-filter-row {
  margin-bottom: 12px;
}
.enroll-filter-row:last-child {
  margin-bottom: 0;
}
.enroll-filter-search {
  width: 100%;
}
.enroll-filter-options {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 32px;
}
.filter-option-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.filter-option-label {
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  min-width: 64px;
}
.filter-chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.filter-chip {
  display: inline-block;
  min-width: 72px;
  padding: 6px 16px;
  font-size: 14px;
  text-align: center;
  color: #555;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s;
}
.filter-chip:hover {
  color: #9A0B00;
  border-color: #91b8ff;
}
.filter-chip.active {
  color: #fff;
  background: #9A0B00;
  border-color: #9A0B00;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(0, 90, 245, 0.25);
}
.enroll-filter-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 14px;
  border-top: 1px dashed #e0e0e0;
}
.enroll-filter-count {
  font-size: 13px;
  color: #666;
}
.enroll-filter-count b {
  color: #9A0B00;
  font-weight: 600;
}
.enroll-select-empty {
  padding: 32px 16px;
  text-align: center;
  color: #999;
  font-size: 14px;
}
.enroll-form-link {
  color: #9A0B00;
}
.enroll-form-link:hover {
  color: #3d7dff;
}
/deep/ .enroll-select-table {
  .ant-table-tbody > tr {
    cursor: pointer;
  }
  .ant-table-tbody > tr > td {
    padding: 8px 10px !important;
    vertical-align: middle;
  }
  .ant-table-thead > tr > th {
    padding: 8px 10px !important;
    background: #fafafa;
    font-weight: 600;
  }
  .enroll-table-row-selected > td {
    background: #e6f0ff !important;
  }
  .ant-table-tbody > tr:hover > td {
    background: #f5f9ff;
  }
  .enroll-table-row-selected:hover > td {
    background: #e6f0ff !important;
  }
}
.table-content-score {
  width: 30px;
  overflow: hidden;
  white-space: nowrap;
  /* margin: 20px 0; */
  /* text-align: center; */
  overflow: hidden;
  text-overflow: ellipsis;
  /* float: right; */
  margin: 0 auto;
  height: 60px;
  line-height: 60px;
}
.table-tr {
  width: 100%;
  display: inline-block;
  text-align: center;
  margin: 0 auto;
  // border-bottom: 1px solid #e8e8e8;
}
/deep/ .table-tr{
  position: relative;
  .ywcimg{
    width: 50px;
    height: 50px;
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
